import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { openAdobeExchange } from '../utils/analytics';
import {
  useLandingNamespace,
  useLanguageLanding,
} from '../context/LanguageLandingContext';
import './CTA.css';
import { isSafariBrowser, scrollReveal } from '../utils/safariMotion';

const CTA: React.FC = () => {
  const safari = isSafariBrowser();
  const { language } = useLanguageLanding();
  const ns = useLandingNamespace();
  const { t } = useTranslation(ns);
  const benefits = t('ctaBenefits', { returnObjects: true }) as string[];

  return (
    <section id="install-cta" className="cta">
      <div className="cta-container">
        <motion.div
          className="cta-content"
          transition={{ duration: 0.8, ease: 'easeOut' }}
          {...scrollReveal(safari, { opacity: 0, y: 30 }, { opacity: 1, y: 0 }, 'section')}>
          <motion.h2
            className="cta-title"
            transition={{ duration: 0.6, delay: 0.2 }}
            {...scrollReveal(safari, { opacity: 0, y: 20 }, { opacity: 1, y: 0 }, 'nested')}>
            {t('ctaTitle')}
          </motion.h2>
          <motion.p
            className="cta-subtitle"
            transition={{ duration: 0.6, delay: 0.4 }}
            {...scrollReveal(safari, { opacity: 0, y: 20 }, { opacity: 1, y: 0 }, 'nested')}>
            {t('ctaSubtitle')}
          </motion.p>
          <motion.div
            className="cta-benefits"
            transition={{ duration: 0.6, delay: 0.6 }}
            {...scrollReveal(safari, { opacity: 0, y: 20 }, { opacity: 1, y: 0 }, 'nested')}>
            {Array.isArray(benefits) &&
              benefits.map((benefit, index) => (
                <motion.div
                  key={benefit}
                  className="benefit"
                  transition={{ duration: 0.5, delay: 0.8 + index * 0.1 }}
                  {...scrollReveal(
                    safari,
                    { opacity: 0, x: -20 },
                    { opacity: 1, x: 0 },
                    'nested'
                  )}
                  whileHover={{ scale: 1.05 }}>
                  <span className="benefit-icon">✓</span>
                  <span>{benefit}</span>
                </motion.div>
              ))}
          </motion.div>
          <motion.button
            type="button"
            className="cta-button"
            transition={{ duration: 0.6, delay: 1.0 }}
            {...scrollReveal(safari, { opacity: 0, y: 20 }, { opacity: 1, y: 0 }, 'nested')}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => {
              openAdobeExchange('cta_section', {
                language: language?.slug ?? null,
              });
            }}>
            {t('getStartedCta')}
          </motion.button>
        </motion.div>
      </div>
    </section>
  );
};

export default CTA;
